import { render } from "./RejectedLiquidations.vue?vue&type=template&id=3a0c36d5"
import script from "./RejectedLiquidations.vue?vue&type=script&lang=js"
export * from "./RejectedLiquidations.vue?vue&type=script&lang=js"

import "./RejectedLiquidations.vue?vue&type=style&index=0&id=3a0c36d5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__